import Api from 'services/api';

// Projetos do Dr. Licita 3.0: segmentam as conversas do chat
// (como no ChatGPT/Claude), via proxy Rails para o agente.

export interface DrLicitaProjeto {
  id: number;
  name: string;
  conversas: number;
  last_activity: string | null;
  created_at: string;
}

export const fetchDrLicitaProjetos = async (): Promise<DrLicitaProjeto[]> => {
  const response = await Api.get('/dr_licita/projetos');
  if (response?.status === 200) return response.data.projects || [];
  return [];
};

export const createDrLicitaProjeto = async (
  name: string,
): Promise<{ id: number; name: string } | null> => {
  const response = await Api.post('/dr_licita/projetos', { name });
  if (response?.status === 201) return response.data.project;
  return null;
};

export const renameDrLicitaProjeto = async (id: number, name: string): Promise<boolean> => {
  const response = await Api.put(`/dr_licita/projetos/${id}`, { name });
  return response?.status === 200;
};

// As conversas do projeto voltam ao histórico geral
export const deleteDrLicitaProjeto = async (id: number): Promise<boolean> => {
  const response = await Api.delete(`/dr_licita/projetos/${id}`);
  return response?.status === 200;
};

export const setChatProjeto = async (
  chatId: number,
  projectId: number | null,
): Promise<boolean> => {
  const response = await Api.put(`/dr_licita/chats/${chatId}/projeto`, { project_id: projectId });
  return response?.status === 200;
};
